
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("4Sylr", function(module, exports) {

$parcel$export(module.exports, "PendoAnalytics", () => $3b794ff5c613897c$export$5b517672761df363);

var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $eriBG = parcelRequire("eriBG");

var $7ZZxN = parcelRequire("7ZZxN");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $9Anw5 = parcelRequire("9Anw5");

var $bNe1g = parcelRequire("bNe1g");

var $gd0Sp = parcelRequire("gd0Sp");

var $jeAvW = parcelRequire("jeAvW");

let $3b794ff5c613897c$var$pendingRequestJira = Promise.resolve();
function $3b794ff5c613897c$var$reportError(error, id, message) {
    // As the operation like initialize/update/teardown are asynchronous, there's a chance that window.pendo
    // could be deleted while switching contexts between JPD and Jira hence the window.pendo might not be available and we would report these issues
    (0, $guiFP.default)({
        meta: {
            id: id,
            packageName: 'jiraCommonPendoAnalytics'
        },
        attributes: {
            message: message
        },
        error: error
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3b794ff5c613897c$var$initializePendoWithChecking = async (apiKey, appName, pendoConfig)=>{
    const id = `pendo-agent-${apiKey}`;
    try {
        if (window.pendo && window.pendo.teardown && apiKey !== window.pendo.apiKey) {
            window.pendo.teardown();
            delete window.pendo;
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        $3b794ff5c613897c$var$reportError(error, 'jiraPendoAnalyticsTeardown', 'Failed to teardown pendo');
    }
    await (0, $eriBG.checkThirdParty)('pendo-main', async ()=>{
        if (!(0, $1ybV0.ff)('pendo-jira-load-only-for-eng-users_q9w6l') || pendoConfig?.visitor?.language_preference.startsWith('en')) {
            let script = document.getElementById(id);
            if (script) {
                // @ts-expect-error as id is not in the global window
                window.pendo = window[id];
                try {
                    if (window?.globalPendoAppName === appName) {
                        const updateInterval = setInterval(()=>{
                            if (window.pendo !== undefined && typeof window.pendo.initialize === 'function' && typeof window.pendo.updateOptions === 'function') {
                                if (apiKey !== window?.pendo?.apiKey) window.pendo.initialize(pendoConfig);
                                else window.pendo.updateOptions(pendoConfig);
                                clearInterval(updateInterval);
                            }
                        }, 1000);
                    }
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    $3b794ff5c613897c$var$reportError(error, 'jiraPendoAnalyticsInitializeUpdate', 'Failed to initialize/update pendo');
                }
            } else {
                // eslint-disable-next-line jira/js/no-document-script
                script = document.createElement('script');
                script.id = id;
                if (script instanceof HTMLScriptElement) script.defer = true;
                script.onload = ()=>{
                    // @ts-expect-error as id is not in the global window
                    window[id] = window.pendo;
                    try {
                        if (window?.globalPendoAppName === appName) {
                            const initializeInterval = setInterval(()=>{
                                if (window.pendo !== undefined && typeof window.pendo.initialize === 'function') {
                                    window.pendo.initialize(pendoConfig);
                                    clearInterval(initializeInterval);
                                }
                            }, 1000);
                        }
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (error) {
                        $3b794ff5c613897c$var$reportError(error, 'jiraPendoAnalyticsInitialize', 'Failed to initialize pendo');
                    }
                };
                if (script instanceof HTMLScriptElement) script.src = `https://cdn.pendo.io/agent/static/${apiKey}/pendo.js`;
                document.head.appendChild(script);
            }
        }
    });
};
const $3b794ff5c613897c$var$addPendoWidget = (props)=>{
    const { atlassianAccountId: atlassianAccountId, cloudId: cloudId, cloudName: cloudName, appEditions: appEditions, apiKey: apiKey, editionKey: editionKey, appName: appName, language: language, displayMode: displayMode } = props;
    // Added Location Config
    const pendoConfig = {
        visitor: {
            id: atlassianAccountId,
            language_preference: language,
            display_mode: displayMode
        },
        account: {
            id: `${appName}-${cloudId}`,
            workspace_name: cloudName,
            edition: editionKey === 'common' ? 'na' : appEditions?.[editionKey]
        },
        location: {
            transforms: [
                {
                    attr: 'href',
                    action: 'Replace',
                    data: (href)=>`${(0, $9Anw5.default)(href)}`
                },
                {
                    attr: 'pathname',
                    action: 'Replace',
                    data: (pathname)=>`${pathname}/${window?.globalPendoAppName}`
                }
            ]
        }
    };
    $3b794ff5c613897c$var$pendingRequestJira = $3b794ff5c613897c$var$pendingRequestJira.then(()=>$3b794ff5c613897c$var$initializePendoWithChecking(apiKey, appName, pendoConfig));
};
const $3b794ff5c613897c$export$5b517672761df363 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { colorMode: colorMode } = (0, $4q38b.default)();
    const loadingRef = (0, $eUqFw.useRef)(false);
    const { loading: loading, error: error, data: data } = (0, $bNe1g.useProjectContext)();
    (0, $eUqFw.useEffect)(()=>{
        // If the project context is loading, we don't want to render the Pendo widget
        // we only want to show pendo when we are inside a project
        if (loading) return;
        // If the project context is loaded, let's make sure that there was no
        // errors and the data exists.
        const projectContextLoaded = !loading && !error && data;
        const isProjectLoaded = loadingRef.current || projectContextLoaded;
        loadingRef.current = loading;
        // Pendo Snippet is only for JWM JSM JSW products and NOT for JPD as they have separate implementation
        if (isProjectLoaded && data?.projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) return;
        // as checked above, there should always be projectType, but we'll provide a
        // sensible default just in case
        const jiraAppName = data?.projectType || (0, $7aa4ec1b6f09c3c0$export$b40f9fec24e148b0);
        const { apiKey: apiKey, appName: appName, editionKey: editionKey } = (0, $jeAvW.APP_KEY_NAME_MAPPING)[jiraAppName];
        window.globalPendoAppName = appName;
        // by this point, we know that we are in a project and we have the correct
        // data to render the pendo widget
        const pendoProps = {
            atlassianAccountId: tenantContext.atlassianAccountId,
            cloudId: tenantContext.cloudId,
            cloudName: tenantContext.cloudName,
            appEditions: tenantContext?.appEditions,
            // By default, the colorThemeObserver will return undefined - that means it is light
            displayMode: colorMode || 'light',
            language: tenantContext.locale,
            appName: appName,
            apiKey: // Fix: Cast appName to AppName type
            apiKey,
            editionKey: editionKey // Assign a default value of type EditionKey
        };
        $3b794ff5c613897c$var$addPendoWidget(pendoProps);
        return ()=>{
            // In non-project area guides should not be displayed. setting it empty means location API will not display any guides.
            window.globalPendoAppName = '';
        };
    }, [
        loading,
        error,
        data,
        tenantContext,
        tenantContext.atlassianAccountId,
        tenantContext.cloudId,
        tenantContext.cloudName,
        tenantContext.locale,
        colorMode,
        loadingRef
    ]);
    return null;
};

});
parcelRegister("eriBG", function(module, exports) {

$parcel$export(module.exports, "checkThirdParty", () => $dc5d8f66e105d173$export$6112f3b5ec1bcd0);

var $j0DJx = parcelRequire("j0DJx");
const $dc5d8f66e105d173$export$6112f3b5ec1bcd0 = async (thirdParty, onAllowed, onDenied)=>{
    await (0, $j0DJx.checkThirdParty)(thirdParty, onAllowed, onDenied);
};

});
parcelRegister("j0DJx", function(module, exports) {

$parcel$export(module.exports, "checkThirdParty", () => $dd6cd6aa669f5062$export$6112f3b5ec1bcd0);

var $XHGTv = parcelRequire("XHGTv");

var $5mY09 = parcelRequire("5mY09");

var $8nVWJ = parcelRequire("8nVWJ");

var $cmTks = parcelRequire("cmTks");
const $dd6cd6aa669f5062$export$6112f3b5ec1bcd0 = async (thirdParty, onAllowed, onDenied)=>{
    if (!(0, $XHGTv.getBooleanFF)('platform.moonjelly.browser-storage-controls')) // If we have no flag, we should be operating as normal and allow all third parties
    return onAllowed();
    try {
        const isAllowed = await (0, $cmTks.isThirdPartyAllowed)(thirdParty);
        (0, $5mY09.sendPackageOperationalEvent)({
            action: 'usedCheckThirdParty',
            attributes: {
                wasRejected: !isAllowed,
                thirdParty: thirdParty
            }
        });
        return isAllowed ? onAllowed() : onDenied === null || onDenied === void 0 ? void 0 : onDenied();
    } catch (e) {
        (0, $8nVWJ.Logger).errorWithOperationalEvent({
            action: 'checkThirdPartyError',
            attributes: {
                wasRejected: true,
                thirdParty: thirdParty
            },
            message: `Failed to use check third party. ${e.message || ''}`
        });
    }
};

});
parcelRegister("cmTks", function(module, exports) {

$parcel$export(module.exports, "isThirdPartyAllowed", () => $901275492fe231b4$export$3df7084d4be668cd);

var $aynK1 = parcelRequire("aynK1");

var $3K9DW = parcelRequire("3K9DW");

var $6c3xv = parcelRequire("6c3xv");
const $901275492fe231b4$export$3df7084d4be668cd = async (thirdParty)=>{
    /*
     If no preferences for whatever reason, deny
     If prefs exist and are default, they will default to allow/block all based on locale
     If third party has no category for whatever reason or the data doesn't resolve, deny
     If third party has a category, check preferences and allow/deny
   */ const preferences = await (0, $6c3xv.getPreferences)();
    if (!preferences) return Promise.resolve(false);
    let shouldDenyThirdParty = false;
    const storageControlsData = await (0, $aynK1.loadStorageControlsData)();
    if (storageControlsData) {
        const { thirdPartyKeys: thirdPartyKeys, categories: categories } = storageControlsData;
        const thirdPartyCategoryNumber = thirdPartyKeys[thirdParty];
        const numToCategoryMap = {
            [categories.STRICTLY_NECESSARY]: (0, $3K9DW.CookieCategory).StrictlyNecessary,
            [categories.FUNCTIONAL]: (0, $3K9DW.CookieCategory).Functional,
            [categories.ANALYTICS]: (0, $3K9DW.CookieCategory).Analytics,
            [categories.MARKETING]: (0, $3K9DW.CookieCategory).Marketing,
            [categories.UNKNOWN]: (0, $3K9DW.CookieCategory).Unknown
        };
        const thirdPartyCategory = thirdPartyCategoryNumber !== null ? numToCategoryMap[thirdPartyCategoryNumber] : null;
        let hasPreferencesForCategoryType = false;
        if (!!thirdPartyCategory) hasPreferencesForCategoryType = preferences[thirdPartyCategory];
        shouldDenyThirdParty = hasPreferencesForCategoryType;
    }
    return Promise.resolve(shouldDenyThirdParty);
};

});
parcelRegister("6c3xv", function(module, exports) {

$parcel$export(module.exports, "getPreferences", () => $48269be877b683bd$export$1de6a888ae076ff8);

var $XHGTv = parcelRequire("XHGTv");

var $3cif2 = parcelRequire("3cif2");

var $fPXpw = parcelRequire("fPXpw");

var $k4bKv = parcelRequire("k4bKv");

var $aiuhL = parcelRequire("aiuhL");
async function $48269be877b683bd$export$1de6a888ae076ff8() {
    // Use V001 pattern without the V2 FF enabled
    if (!(0, $XHGTv.getBooleanFF)('platform.moonjelly.browser-storage-controls-v2')) {
        const packedPrefs = (0, $k4bKv.getCookie)((0, $3cif2.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return (0, $aiuhL.unpackUserPreferencesCookie)(packedPrefs);
    }
    let packedLocalPrefs = (0, $k4bKv.getCookie)((0, $3cif2.ATLASSIAN_CONSENT_COOKIE_KEY));
    if (!packedLocalPrefs) {
        const consentToken = await (0, $fPXpw.getConsentToken)();
        return consentToken ? (0, $aiuhL.unpackUserPreferencesCookie)(consentToken) : undefined;
    }
    return (0, $aiuhL.unpackUserPreferencesCookie)(packedLocalPrefs);
}

});
parcelRegister("fPXpw", function(module, exports) {

$parcel$export(module.exports, "getConsentToken", () => $b879b4206b30fa3d$export$f1b8f2ca713fca08);

var $3cif2 = parcelRequire("3cif2");

var $k4bKv = parcelRequire("k4bKv");

var $4Qq0u = parcelRequire("4Qq0u");

var $kRieG = parcelRequire("kRieG");

var $3ONDH = parcelRequire("3ONDH");
const $b879b4206b30fa3d$export$f1b8f2ca713fca08 = async ()=>{
    const fallbackConsentToken = (0, $k4bKv.getCookie)((0, $3cif2.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const consentData = await (0, $3ONDH.getValidConsentData)(fallbackConsentToken);
    if (consentData) {
        const { consentToken: consentToken, currentLocale: currentLocale, consentTimestamp: consentTimestamp } = consentData;
        /*** TESTING OVERRIDES ***/ const potentiallyOverriddenLocale = (0, $4Qq0u.overrideLocaleForLiveTesting)(currentLocale);
        const potentiallyOverriddenConsentToken = (0, $4Qq0u.overrideConsentTokenForLiveTesting)(consentToken);
        const testingConsentOverride = (0, $k4bKv.getCookie)((0, $3cif2.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
        const hasTestingConsents = !!(testingConsentOverride || testingConsentOverride === '');
        if (hasTestingConsents) {
            // If testing, set the cookies accordingly so we can test with any overridden token data.
            (0, $kRieG.setCurrentLocaleCookie)(potentiallyOverriddenLocale);
            (0, $kRieG.setShouldShowBannerCookie)(potentiallyOverriddenConsentToken, potentiallyOverriddenLocale);
            (0, $kRieG.setConsentTokenCookie)(potentiallyOverriddenConsentToken);
            // Unfortunately, if you've previously saved to ConsentHub, that data will always resolve, so to simulate ConsentHub
            // being down, or the token data being bunk/invalid, we must set the testing token to an empty string. This will
            // return undefined here and skip any unpacking of the token. Otherwise, it will use the overridden token value.
            return potentiallyOverriddenConsentToken === '' ? undefined : potentiallyOverriddenConsentToken;
        }
        // At this point, all data should be valid and overridden for testing as needed, so set those cookies!
        (0, $kRieG.setRequiredConsentCookies)(potentiallyOverriddenConsentToken, potentiallyOverriddenLocale, consentTimestamp);
        return consentToken;
    }
    return undefined;
};

});
parcelRegister("4Qq0u", function(module, exports) {

$parcel$export(module.exports, "overrideLocaleForLiveTesting", () => $387031307da5b06e$export$c3ac60327bcccc48);
$parcel$export(module.exports, "overrideConsentTokenForLiveTesting", () => $387031307da5b06e$export$b5282052fc15e1ae);

var $3cif2 = parcelRequire("3cif2");

var $k4bKv = parcelRequire("k4bKv");
const $387031307da5b06e$export$c3ac60327bcccc48 = (genuineCurrentLocale)=>{
    const localeOverride = (0, $k4bKv.getCookie)((0, $3cif2.TESTING_LOCALE_OVERRIDE_COOKIE_KEY));
    // Note: Clear this cookie out of your browser when you're done testing different locales
    // Or you'll be stuck looking at an invalid locale
    return localeOverride || genuineCurrentLocale;
};
const $387031307da5b06e$export$b5282052fc15e1ae = (genuineConsentToken)=>{
    // The existence of this cookie will make it look like fetched ConsentHub data is missing
    // You can set it to undefined yourself/empty string, or an actual default value.
    const tokenOverride = (0, $k4bKv.getCookie)((0, $3cif2.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
    // Note: Clear this cookie out of your browser when you're done testing empty data sets
    // Or you'll be stuck seeing the banner and never actually consenting on the UI
    return tokenOverride || genuineConsentToken;
};

});

parcelRegister("3ONDH", function(module, exports) {

$parcel$export(module.exports, "getValidConsentData", () => $2c7c8bebb6fad504$export$c515de1cc9cebc71);

var $cRRop = parcelRequire("cRRop");

var $aiuhL = parcelRequire("aiuhL");
const $2c7c8bebb6fad504$export$c515de1cc9cebc71 = async (fallbackConsentToken)=>{
    // Fetches preferences from ConsentHub and returns serialized token data if possible
    const consentData = await (0, $cRRop.fetchConsentPreferences)();
    let { consentToken: consentToken, currentLocale: currentLocale, consentTimestamp: consentTimestamp, consentHubInaccessible: consentHubInaccessible } = consentData;
    let { isValid: isValid } = (0, $aiuhL.checkTokenValidity)(consentToken);
    if (isValid && consentHubInaccessible && fallbackConsentToken) // `consentHubInaccessible`: ConsentHub request failed (e.g. service is down/bad request/etc). Attempt to use
    // any previously set consents in the interim if we have them.
    consentToken = fallbackConsentToken;
    return isValid ? {
        consentToken: consentToken,
        currentLocale: currentLocale,
        consentTimestamp: consentTimestamp
    } : undefined;
};

});






parcelRegister("jeAvW", function(module, exports) {

$parcel$export(module.exports, "APP_KEY_NAME_MAPPING", () => $4d17312054f173f7$export$e1484ba0e8570538);
const $4d17312054f173f7$var$API_KEY_JIRA = '0678af2a-df89-42a3-4abb-60978aa54814';
const $4d17312054f173f7$export$e1484ba0e8570538 = {
    business: {
        apiKey: $4d17312054f173f7$var$API_KEY_JIRA,
        appName: 'jwm',
        editionKey: 'core'
    },
    software: {
        apiKey: $4d17312054f173f7$var$API_KEY_JIRA,
        appName: 'jsw',
        editionKey: 'software'
    },
    service_desk: {
        apiKey: $4d17312054f173f7$var$API_KEY_JIRA,
        appName: 'jsm',
        editionKey: 'serviceDesk'
    },
    common: {
        apiKey: $4d17312054f173f7$var$API_KEY_JIRA,
        appName: 'common',
        editionKey: 'common'
    },
    product_discovery: {
        apiKey: '',
        appName: 'jpd',
        editionKey: 'productDiscovery'
    }
};

});

const $7aa4ec1b6f09c3c0$export$b40f9fec24e148b0 = 'common';



//# sourceMappingURL=async-pendo-analytics.52c73240.js.map
